import axiosInstance from "@/utils/axiosInstance";

export interface PortfolioTenantSummary {
  tenant_id: number;
  tenant_name: string;
  tenant_slug: string;
  pending_submissions: number;
  active_assignments: number;
  unassigned_open_submissions: number;
  stale_assignments: number;
  routing_failures: number;
  locked_submissions: number;
  total_applications_disbursed: number;
}

export interface PortfolioOverviewResponse {
  scope: "cross_tenant_supervisory";
  read_only: boolean;
  user_id: number;
  role: string;
  tenant_count: number;
  totals: {
    pending_submissions: number;
    active_assignments: number;
    unassigned_open_submissions: number;
    stale_assignments: number;
    routing_failures: number;
    locked_submissions: number;
    total_applications_disbursed: number;
  };
  tenants: PortfolioTenantSummary[];
}

export interface PortfolioOverviewParams {
  date_from?: string;
  date_to?: string;
  program_code?: string;
  academic_year?: number;
  applicant_name?: string;
}

export async function fetchPortfolioOverview(
  params?: PortfolioOverviewParams
): Promise<PortfolioOverviewResponse> {
  const res = await axiosInstance.get<PortfolioOverviewResponse>("/portfolio/overview", {
    params,
  });
  return res.data;
}
